import React from "react";
import api from "../api";
import { toast } from "sonner";

import MobileMenu from "./components/MobileMenu";
import PageFooter from "./components/PageFooter";
import Viewport from "./components/Viewport";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import { BsEye } from "react-icons/bs";
import { FiCheck } from "react-icons/fi";
import spinner from "../images/Spinnerblack.svg";

const Signup = () => {
  const { width } = Viewport();
  const [inactiveMobileNav, activeMobileNav] = useState(false);
  const breakpoint = 558;

  const navigate = useNavigate();

  const [signupValues, setsignupValues] = useState({
    email: "",
    password: "",
    phone: "",
    authcode: "",
    username: "",
    cpassword: "",
  });
  const [isLoadingBtn, updateisLoadingBtn] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [errorMessagesDefault, errorMessageUpdate] = useState([]);

  const signupSubmit = async (e) => {
    e.preventDefault();
    updateisLoadingBtn(true);
    setIsButtonDisabled(true);

    try {
      const regResponse = await api.post("/api/signup", { ...signupValues });
      const regResponseData = regResponse.data;

      if (regResponseData.errors) {
        setsignupValues({
          email: regResponseData.email,
          username: regResponseData.username,
          phone: regResponseData.phone,
          password: "",
          cpassword: "",
          authcode: "",
        });

        const newErrorMessages = regResponseData.errors.map(
          (error) => error.msg,
        );

        errorMessageUpdate([...newErrorMessages]);
        window.scroll(0, 0);
        updateisLoadingBtn(false);
        setIsButtonDisabled(false);
      } else {
        const succRegMsg = regResponseData.successMsg;
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success(succRegMsg);
        updateisLoadingBtn(false);
        setSubmitted(true);

        setTimeout(() => {
          setIsButtonDisabled(false);
          navigate("/completesignup");
        }, 3000);
      }
    } catch (error) {
      console.log("error");
      updateisLoadingBtn(false);
      setIsButtonDisabled(false);
    }
  };

  useEffect(() => {
    const displayErrorMessages = () => {
      errorMessagesDefault.forEach((errorMessage) => {
        if (errorMessage) {
          toast.error(errorMessage);
        }
      });
    };

    displayErrorMessages();
  }, [errorMessagesDefault]);

  const [showPassword, setShowPassword] = useState(false);
  const [showcPassword, setShowcPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const togglecPasswordVisibility = () => {
    setShowcPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div className="relative overflow-hidden flex flex-col justify-start items-center bg-mainBackColor text-white w-full p-[1rem] min-h-screen ">
      <MobileMenu
        closeMobileMenu={() => { activeMobileNav(false); }}
        translateAction={
          inactiveMobileNav ? `translate-y-[0px]` : `translate-y-[-1500px]`
        }
      />

      {
        <nav className="relative flex justify-between items-center min-h-[4rem] w-full md:w-[80%]">
          <Link to="/" className="relative flex justify-start items-center h-full">
            <span className="font-logo font-[700] text-[18px] tracking-tight text-white">Zenit<span className="text-userDashPurple">chain</span></span>
          </Link>

          {width < breakpoint ? (
            <button className="flex" onClick={() => activeMobileNav(true)}>
              <AiOutlineMenu className="text-white font-[500] text-[24px]" />
            </button>
          ) : (
            ""
          )}

          <div className="hidden justify-between items-center sm:flex">
            <ul className="flex space-x-10">
              <li className="text-primaryGreen font-[500] text-[15.5px]">
                {" "}
                <Link to="/Signin">Trade</Link>{" "}
              </li>
              <li className="text-primaryGreen font-[500] text-[15.5px]">
                {" "}
                <Link to="/about">About</Link>{" "}
              </li>
              <li className="text-primaryGreen font-[500] text-[15.5px]">
                {" "}
                <Link to="/airdrops">Airdrops</Link>{" "}
              </li>
            </ul>
          </div>
        </nav>
      }

      <div className="relative py-[4rem] min-h-[10rem] w-full flex flex-col justify-start items-start space-y-[2rem] md:w-[80%]">
        <div className="relative w-full flex flex-col justify-start items-start">
          <h1 className="text-white text-[22px] font-[550]">
            Welcome To ZenitChain
          </h1>
          <p className="text-white pb-[1rem]">
            Create an account or{" "}
            <Link to="/signin" className="text-primaryGreen">
              log in
            </Link>
            .{" "}
          </p>
        </div>

        {submitted ? (
          <div className="flex flex-col items-start space-y-4 py-[2rem]">
            <div className="w-[48px] h-[48px] rounded-full bg-primaryGreen/10 border border-primaryGreen/30 flex justify-center items-center">
              <FiCheck className="text-primaryGreen text-[22px]" />
            </div>
            <h2 className="text-white text-[20px] font-[550]">Account created!</h2>
            <p className="text-[#ACACB5] text-[15px]">Taking you to verification...</p>
          </div>
        ) : (
        <form action="" onSubmit={(e) => signupSubmit(e)}>
          <div className="relative w-full flex flex-col space-y-4">
            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <label htmlFor="email" className="text-[15px] text-left text-white font-[450]">
                Email
              </label>
              <input
                type="text"
                name="email"
                value={signupValues.email}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen"
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <label htmlFor="username" className="text-[15px] text-left text-white font-[450]">
                Username
              </label>
              <input
                type="text"
                name="username"
                value={signupValues.username}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen"
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <label htmlFor="phone" className="text-[15px] text-left text-white font-[450]">
                Phone
              </label>
              <input
                type="tel"
                name="phone"
                value={signupValues.phone}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen"
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <label htmlFor="authcode" className="text-[15px] text-left text-white font-[450]">
                Referral Code
              </label>
              <input
                type="text"
                name="authcode"
                value={signupValues.authcode}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen"
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <div className="w-full flex justify-between sm:w-[450px]">
                <label htmlFor="password" className="text-[15px] text-left text-white font-[450]">
                  Password
                </label>
                <button type="button" onClick={togglePasswordVisibility} className="flex items-center justify-end text-[14px]">
                  <BsEye className="text-primaryGreen mr-[5px] text-[16px]" />
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={signupValues.password}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen"
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <div className="relative w-full flex flex-col justify-start items-start space-y-2 ">
              <div className="w-full flex justify-between sm:w-[450px]">
                <label htmlFor="cpassword" className="text-[15px] text-left text-white font-[450]">
                  Confirm Password
                </label>
                <button type="button" onClick={togglecPasswordVisibility} className="flex items-center justify-end text-[14px]">
                  <BsEye className="text-primaryGreen mr-[5px] text-[16px]" />
                  {showcPassword ? "Hide" : "Show"}
                </button>
              </div>

              <input
                type={showcPassword ? "text" : "password"}
                name="cpassword"
                value={signupValues.cpassword}
                className="bg-mainBackColor px-2 border-[#d9d9d9] border-[1px] rounded-[2px] w-full h-[45px] text-white text-[16px] sm:w-[450px] focus:outline-none focus:border-primaryGreen "
                onChange={(e) => setsignupValues({ ...signupValues, [e.target.name]: e.target.value })}
              />
            </div>

            <p className="text-[14px] text-[#5F6377] sm:w-[450px]">
              By clicking the 'Sign Up' button, you are creating a Zenitchain
              account, and you agree to Zenitchain's{" "}
              <span className="text-primaryGreen cursor-pointer">
                Terms of Use{" "}
              </span>
              and{" "}
              <span className="text-primaryGreen cursor-pointer">
                Privacy Policy.
              </span>
            </p>

            <button
              type="submit"
              disabled={isButtonDisabled}
              className="bg-primaryGreen text-white border-primaryGreen rounded-md flex justify-center items-center text-center w-full h-[50px] sm:w-[450px]"
            >
              {isLoadingBtn ? (
                <img src={spinner} className="w-[50px] h-[50px]" alt="loading" />
              ) : (
                <p>Sign Up</p>
              )}
            </button>
          </div>
        </form>
        )}
      </div>

      <PageFooter />
    </div>
  );
};

export default Signup;
